// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const kratorplusColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#9841A6',
  secondary: '#9841A6',
}

export const darkTheme = {
  colors: kratorplusColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: kratorplusColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: kratorplusColors.primaryGray,
    secondary: kratorplusColors.secondaryGray,
    disabled: kratorplusColors.grayText,
    link: kratorplusColors.secondaryGray,
    hint: kratorplusColors.white,
    highlight: kratorplusColors.secondary,
    gray: kratorplusColors.primaryGray,
    seeAll: kratorplusColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: kratorplusColors.primaryGray,
    gray: kratorplusColors.secondaryGray,
  },
  filter: {
    primary: kratorplusColors.primaryGray,
    secondary: kratorplusColors.secondaryGray,
    disabled: kratorplusColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: kratorplusColors.dark,
    color: kratorplusColors.white,
    border: kratorplusColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: kratorplusColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: kratorplusColors.dark,
        selected: kratorplusColors.dark,
        progress: rgba(kratorplusColors.primary, 0.3),
        past: rgba(kratorplusColors.primary, 0.3),
        pastSelected: kratorplusColors.dark,
        pastHover: kratorplusColors.dark,
        empty: '#555555',
        emptyProgress: rgba(kratorplusColors.primary, 0.2),
      },
      text: {
        empty: kratorplusColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: kratorplusColors.white,
    subTitle: kratorplusColors.secondaryGray,
    bg: kratorplusColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 158,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
